module.exports = __webpack_public_path__ + "static/img/pingtaibg.922c0614.png";